import { useNavigate, useLocation } from "react-router-dom";
import { Shield, Users } from "lucide-react";

/**
 * Segmented Admin | Staff view toggle for admins. Highlights the active view
 * based on the current route. Placed top-left of admin & staff portals.
 */
const ViewToggle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isStaffView = location.pathname.startsWith("/staff-schedule");

  const base = "flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold transition-colors";
  const active = "bg-[#39FF14] text-black";
  const inactive = "text-[#A1A1AA] hover:text-white";

  return (
    <div data-testid="view-mode-toggle" className="inline-flex items-center bg-[#0A0A0A] border border-[#27272A] rounded-full p-1">
      <button
        type="button"
        data-testid="toggle-admin-view"
        onClick={() => navigate("/dashboard")}
        className={`${base} ${!isStaffView ? active : inactive}`}
      >
        <Shield className="w-4 h-4" /> Admin
      </button>
      <button
        type="button"
        data-testid="toggle-staff-view"
        onClick={() => navigate("/staff-schedule")}
        className={`${base} ${isStaffView ? active : inactive}`}
      >
        <Users className="w-4 h-4" /> Staff
      </button>
    </div>
  );
};

export default ViewToggle;
